import React from 'react';

const HeaderButtonNav = ({ children }) => (
  <div className="app-header-button-nav">{children}</div>
);

export default HeaderButtonNav;
